"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Table;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _Status = require("../../../../atoms/Status");

var _CheckBox = require("../../../../atoms/CheckBox");

var _ImageGroup = _interopRequireDefault(require("../ImageGroup"));

var _helper = require("../../../../../_utils/helper");

var _styles = require("./styles");

var _utils = require("./utils");

var _jsxRuntime = require("react/jsx-runtime");

function Table(props) {
  var _useState = (0, _react.useState)([]),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      headers = _useState2[0],
      setHeaders = _useState2[1];

  var _useState3 = (0, _react.useState)([]),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      values = _useState4[0],
      setValues = _useState4[1];

  var _useState5 = (0, _react.useState)({
    wides: [],
    types: [],
    extends: []
  }),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      config = _useState6[0],
      setConfig = _useState6[1];

  var _useState7 = (0, _react.useState)(-1),
      _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
      showExtends = _useState8[0],
      setShowExtends = _useState8[1];

  (0, _react.useEffect)(function () {
    var tempConfig = {
      wides: [],
      types: [],
      extends: []
    };
    var headersName = [];
    var values = [];
    props.headers.forEach(function (_ref) {
      var width = _ref.width,
          name = _ref.name,
          type = _ref.type;
      tempConfig.wides.push(width);
      tempConfig.types.push(type);
      headersName.push(name);
    });
    Object.entries(props.data).forEach(function (_ref2) {
      var _ref3 = (0, _slicedToArray2.default)(_ref2, 2),
          key = _ref3[0],
          columns = _ref3[1];

      var copy = columns.extends ? Object.entries(columns.extends).map(function (_ref4) {
        var _ref5 = (0, _slicedToArray2.default)(_ref4, 2),
            keyExt = _ref5[0],
            columnsExt = _ref5[1];

        return {
          key: keyExt,
          columns: columnsExt
        };
      }) : undefined;
      tempConfig.extends.push(copy);
      values.push({
        key: key,
        columns: columns
      });
    });
    setValues(values);
    setHeaders(headersName);
    setConfig(tempConfig);
  }, [props.data, props.headers]);

  var getTypeColumn = function getTypeColumn(index, key, value, id, isDetail) {
    switch (config.types[index]) {
      case "groupImages":
        var images = [];

        if (value.length > 4) {
          var remaining = value.length - 3;
          value.forEach(function (e, i) {
            if (i >= 3) return;
            images.push((0, _objectSpread2.default)((0, _objectSpread2.default)({}, e), {}, {
              src: (0, _helper.getRetailerPicture)(e.id)
            }));
          });
          images.push({
            id: -1,
            src: "+".concat(remaining),
            name: "+".concat(remaining, " Cadenas")
          });
        } else {
          images = value.map(function (e) {
            return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, e), {}, {
              src: (0, _helper.getRetailerPicture)(e.id)
            });
          });
        }

        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ImageGroup.default, {
          images: images
        });

      case "services":
        return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "flex",
          children: value.map(function (e) {
            return _utils.servicesCodeIcon[e];
          })
        });

      case "status":
        return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "center",
          children: value && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Status.Status, {
            statusType: value
          })
        });

      case "checkout":
        return !isDetail && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "center CheckBoxTable",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_CheckBox.CheckBox, {
            id: "".concat(key, "-").concat(id),
            onChange: function onChange(e) {
              e.stopPropagation();
              value && value.onChange(id, e.target.checked);
            },
            defaultChecked: value.value,
            disabled: props.isProvider
          })
        });

      default:
        return value;
    }
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Header, {
      children: headers.map(function (headers, i) {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Column, {
          width: config.wides[i],
          isHeader: true,
          children: headers
        }, "header-".concat(i));
      })
    }), values.map(function (v, index) {
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Rows, {
          index: index,
          onClick: function onClick() {
            return setShowExtends(showExtends === index ? -1 : index);
          },
          children: Object.entries(v.columns).map(function (_ref6, i) {
            var _ref7 = (0, _slicedToArray2.default)(_ref6, 2),
                key = _ref7[0],
                c = _ref7[1];

            return key !== "extends" && /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Column, {
              width: config.wides[i],
              children: getTypeColumn(i, key, c, v.key)
            }, "".concat(v.key, "-").concat(i));
          })
        }, "row-".concat(v.key)), showExtends === index && config.extends[index] && Object.values(config.extends[index]).map(function (v, idx) {
          return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Rows, {
            index: idx,
            children: Object.entries(v.columns).map(function (_ref8, i) {
              var _ref9 = (0, _slicedToArray2.default)(_ref8, 2),
                  key = _ref9[0],
                  c = _ref9[1];

              return key !== "extends" && /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Column, {
                width: config.wides[i],
                children: getTypeColumn(i, key, c, v.key, true)
              }, "extends-".concat(v.key, "-").concat(i));
            })
          }, "extends-".concat(v.key));
        })]
      });
    })]
  });
}